import { Badge } from '@chakra-ui/core';
import React from 'react';

const LOCALE_BADGE_STYLES: Record<string, { color: string; borderColor: string; bg: string }> = {
  en: {
    color: '#1F3CBA',
    borderColor: '#1F3CBA',
    bg: 'rgba(31,60,186,0.1)',
  },
  fr: {
    color: '#8200DB',
    borderColor: '#8200DB',
    bg: 'rgba(130,0,219,0.1)',
  },
};

type LocaleBadgeProps = {
  locale?: string;
};

export const LocaleBadge = ({ locale }: LocaleBadgeProps) => {
  if (!locale || !(locale in LOCALE_BADGE_STYLES)) return null;

  const styles = LOCALE_BADGE_STYLES[locale];

  return (
    <Badge
      display="inline-flex"
      width="32px"
      height="24px"
      justifyContent="center"
      alignItems="center"
      fontSize="14px"
      fontWeight="400"
      borderRadius="md"
      px={2}
      py={1}
      ml={2}
      border="1px solid"
      {...styles}
    >
      {locale}
    </Badge>
  );
};

LocaleBadge.defaultProps = {
  locale: '',
};
